export enum Viewport {
	SMARTPHONE = 'smartphone', // max 512
	TABLET = 'tablet', // max 960
	DESKTOP = 'desktop', // 960+
}
